<template>
  <div>
    <!-- section 1 - title, tabs -->
    <div class="section-1-wrapper">
      <!-- section 1 (show-over-1537px) -->
      <div class="show-over-1537px section-1" style="width: 100%; padding: 150px 0px 130px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex flex-column align-center" style="width: 1536px">
            <!-- section title -->
            <div style="font-size: 60px; font-weight: 300; line-height: 135%; letter-spacing: -0.02em; color: #ffffff">
              작업은 시스템이, 결정은 사람이 하는
            </div>
            <div style="font-size: 60px; font-weight: 700; line-height: 135%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 32px">
              AI-Powered Workflow Automation
            </div>
            <!-- 문의하기 버튼 -->
            <div @click="openGoogleForm()" :style="{marginBottom: '120px'}"
              class="hover-bg-color-important d-flex align-center justify-center"
              style="--hover-bg-color: #EB3A00; height: 50px; padding: 0px 36px; background-color: #FF6A39; border-radius: 999px; cursor: pointer"
            >
              <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
                문의하기
              </div>
            </div>
            <!-- 탭 - 비즈니스 프로세스, 노코드 워크플로우, 데이터 표준화, 문서 자동 생성, 데이터 시각화 -->
            <div class="d-flex" style="width: 100%; height: 63px">
              <!-- 비즈니스 프로세스 -->
              <div @click="section1_tab = 0"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 0 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 0 ? {fontWeight: 700} : {}"
                >
                  비즈니스 프로세스
                </div>
              </div>
              <!-- 노코드 워크플로우 -->
              <div @click="section1_tab = 1"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 1 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 1 ? {fontWeight: 700} : {}"
                >
                  노코드 워크플로우
                </div>
              </div>
              <!-- 데이터 표준화 -->
              <div @click="section1_tab = 2"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 2 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 2 ? {fontWeight: 700} : {}"
                >
                  데이터 표준화
                </div>
              </div>
              <!-- 문서 자동 생성 -->
              <div @click="section1_tab = 3"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 3 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 3 ? {fontWeight: 700} : {}"
                >
                  문서 자동 생성
                </div>
              </div>
              <!-- 데이터 시각화 -->
              <div @click="section1_tab = 4"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 4 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 4 ? {fontWeight: 700} : {}"
                >
                  데이터 시각화
                </div>
              </div>
            </div>
            <!-- 탭 내용 -->
            <div style="width: 100%">
              <!-- 비즈니스 프로세스 -->
              <div v-show="section1_tab === 0" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  복잡한 업무 흐름을 변경없이 그대로 자동화합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab1_img.svg" style="width: 100%">
              </div>
              <!-- 노코드 워크플로우 -->
              <div v-show="section1_tab === 1" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  데이터 처리부터 AI Agent까지, 드래그 & 드롭 모듈로 빠르게 구축하고 수정하세요
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab2_img.svg" style="width: 100%">
              </div>
              <!-- 데이터 표준화 -->
              <div v-show="section1_tab === 2" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  분산된 데이터를 사람이 쉽게 인식하도록 표준화하여, 의사결정에만 집중하도록 합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab3_img.svg" style="width: 100%">
              </div>
              <!-- 문서 자동 생성 -->
              <div v-show="section1_tab === 3" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  데이터에 기업 고유의 양식을 적용하여 문서를 자동으로 생성합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab4_img.svg" style="width: 100%">
              </div>
              <!-- 데이터 시각화 -->
              <div v-show="section1_tab === 4" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  복잡한 설정 없이 영역 지정만으로 인사이트 대시보드를 완성하세요
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab5_img.svg" style="width: 100%">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- section 1 (show-over-1281px-under-1536px) -->
      <div class="show-over-1281px-under-1536px section-1" style="width: 100%; padding: 150px 0px 130px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex flex-column align-center" style="width: 1181px">
            <!-- section title -->
            <div style="font-size: 60px; font-weight: 300; line-height: 135%; letter-spacing: -0.02em; color: #ffffff">
              작업은 시스템이, 결정은 사람이 하는
            </div>
            <div style="font-size: 60px; font-weight: 700; line-height: 135%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 32px">
              AI-Powered Workflow Automation
            </div>
            <!-- 문의하기 버튼 -->
            <div @click="openGoogleForm()" :style="{marginBottom: '120px'}"
              class="hover-bg-color-important d-flex align-center justify-center"
              style="--hover-bg-color: #EB3A00; height: 50px; padding: 0px 36px; background-color: #FF6A39; border-radius: 999px; cursor: pointer"
            >
              <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
                문의하기
              </div>
            </div>
            <!-- 탭 - 비즈니스 프로세스, 노코드 워크플로우, 데이터 표준화, 문서 자동 생성, 데이터 시각화 -->
            <div class="d-flex" style="width: 100%; height: 63px">
              <!-- 비즈니스 프로세스 -->
              <div @click="section1_tab = 0"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 0 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 0 ? {fontWeight: 700} : {}"
                >
                  비즈니스 프로세스
                </div>
              </div>
              <!-- 노코드 워크플로우 -->
              <div @click="section1_tab = 1"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 1 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 1 ? {fontWeight: 700} : {}"
                >
                  노코드 워크플로우
                </div>
              </div>
              <!-- 데이터 표준화 -->
              <div @click="section1_tab = 2"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 2 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 2 ? {fontWeight: 700} : {}"
                >
                  데이터 표준화
                </div>
              </div>
              <!-- 문서 자동 생성 -->
              <div @click="section1_tab = 3"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 3 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 3 ? {fontWeight: 700} : {}"
                >
                  문서 자동 생성
                </div>
              </div>
              <!-- 데이터 시각화 -->
              <div @click="section1_tab = 4"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 4 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 22px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 4 ? {fontWeight: 700} : {}"
                >
                  데이터 시각화
                </div>
              </div>
            </div>
            <!-- 탭 내용 -->
            <div style="width: 100%">
              <!-- 비즈니스 프로세스 -->
              <div v-show="section1_tab === 0" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  복잡한 업무 흐름을 변경없이 그대로 자동화합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab1_img.svg" style="width: 100%">
              </div>
              <!-- 노코드 워크플로우 -->
              <div v-show="section1_tab === 1" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  데이터 처리부터 AI Agent까지, 드래그 & 드롭 모듈로 빠르게 구축하고 수정하세요
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab2_img.svg" style="width: 100%">
              </div>
              <!-- 데이터 표준화 -->
              <div v-show="section1_tab === 2" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  분산된 데이터를 사람이 쉽게 인식하도록 표준화하여, 의사결정에만 집중하도록 합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab3_img.svg" style="width: 100%">
              </div>
              <!-- 문서 자동 생성 -->
              <div v-show="section1_tab === 3" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  데이터에 기업 고유의 양식을 적용하여 문서를 자동으로 생성합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab4_img.svg" style="width: 100%">
              </div>
              <!-- 데이터 시각화 -->
              <div v-show="section1_tab === 4" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  복잡한 설정 없이 영역 지정만으로 인사이트 대시보드를 완성하세요
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab5_img.svg" style="width: 100%">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- section 1 (show-over-1025px-under-1280px) -->
      <div class="show-over-1025px-under-1280px section-1" style="width: 100%; padding: 150px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex flex-column align-center" style="width: 925px">
            <!-- section title -->
            <div style="font-size: 50px; font-weight: 300; line-height: 135%; letter-spacing: -0.02em; color: #ffffff">
              작업은 시스템이, 결정은 사람이 하는
            </div>
            <div style="font-size: 50px; font-weight: 700; line-height: 135%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 32px">
              AI-Powered Workflow Automation
            </div>
            <!-- 문의하기 버튼 -->
            <div @click="openGoogleForm()" :style="{marginBottom: '120px'}"
              class="hover-bg-color-important d-flex align-center justify-center"
              style="--hover-bg-color: #EB3A00; height: 50px; padding: 0px 36px; background-color: #FF6A39; border-radius: 999px; cursor: pointer"
            >
              <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
                문의하기
              </div>
            </div>
            <!-- 탭 - 비즈니스 프로세스, 노코드 워크플로우, 데이터 표준화, 문서 자동 생성, 데이터 시각화 -->
            <div class="d-flex" style="width: 100%; height: 60px">
              <!-- 비즈니스 프로세스 -->
              <div @click="section1_tab = 0"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 0 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 20px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 0 ? {fontWeight: 700} : {}"
                >
                  비즈니스 프로세스
                </div>
              </div>
              <!-- 노코드 워크플로우 -->
              <div @click="section1_tab = 1"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 1 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 20px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 1 ? {fontWeight: 700} : {}"
                >
                  노코드 워크플로우
                </div>
              </div>
              <!-- 데이터 표준화 -->
              <div @click="section1_tab = 2"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 2 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 20px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 2 ? {fontWeight: 700} : {}"
                >
                  데이터 표준화
                </div>
              </div>
              <!-- 문서 자동 생성 -->
              <div @click="section1_tab = 3"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 3 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 20px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 3 ? {fontWeight: 700} : {}"
                >
                  문서 자동 생성
                </div>
              </div>
              <!-- 데이터 시각화 -->
              <div @click="section1_tab = 4"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 4 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 20px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 4 ? {fontWeight: 700} : {}"
                >
                  데이터 시각화
                </div>
              </div>
            </div>
            <!-- 탭 내용 -->
            <div style="width: 100%">
              <!-- 비즈니스 프로세스 -->
              <div v-show="section1_tab === 0" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 20px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  복잡한 업무 흐름을 변경없이 그대로 자동화합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab1_img.svg" style="width: 100%">
              </div>
              <!-- 노코드 워크플로우 -->
              <div v-show="section1_tab === 1" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 20px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  데이터 처리부터 AI Agent까지, 드래그 & 드롭 모듈로 빠르게 구축하고 수정하세요
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab2_img.svg" style="width: 100%">
              </div>
              <!-- 데이터 표준화 -->
              <div v-show="section1_tab === 2" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 20px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  분산된 데이터를 사람이 쉽게 인식하도록 표준화하여, 의사결정에만 집중하도록 합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab3_img.svg" style="width: 100%">
              </div>
              <!-- 문서 자동 생성 -->
              <div v-show="section1_tab === 3" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 20px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  데이터에 기업 고유의 양식을 적용하여 문서를 자동으로 생성합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab4_img.svg" style="width: 100%">
              </div>
              <!-- 데이터 시각화 -->
              <div v-show="section1_tab === 4" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 20px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 24px 0px">
                  복잡한 설정 없이 영역 지정만으로 인사이트 대시보드를 완성하세요
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab5_img.svg" style="width: 100%">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- section 1 (show-over-769px-under-1024px) -->
      <div class="show-over-769px-under-1024px section-1" style="width: 100%; padding: 120px 0px 90px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex flex-column align-center" style="width: 709px">
            <!-- section title -->
            <div style="font-size: 40px; font-weight: 300; line-height: 135%; letter-spacing: -0.02em; color: #ffffff">
              작업은 시스템이, 결정은 사람이 하는
            </div>
            <div style="font-size: 40px; font-weight: 700; line-height: 135%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 32px">
              AI-Powered Workflow Automation
            </div>
            <!-- 문의하기 버튼 -->
            <div @click="openGoogleForm()" :style="{marginBottom: '80px'}"
              class="hover-bg-color-important d-flex align-center justify-center"
              style="--hover-bg-color: #EB3A00; height: 50px; padding: 0px 36px; background-color: #FF6A39; border-radius: 999px; cursor: pointer"
            >
              <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
                문의하기
              </div>
            </div>
            <!-- 탭 - 비즈니스 프로세스, 노코드 워크플로우, 데이터 표준화, 문서 자동 생성, 데이터 시각화 -->
            <div class="d-flex" style="width: 100%; height: 56px">
              <!-- 비즈니스 프로세스 -->
              <div @click="section1_tab = 0"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 0 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 0 ? {fontWeight: 700} : {}"
                >
                  비즈니스 프로세스
                </div>
              </div>
              <!-- 노코드 워크플로우 -->
              <div @click="section1_tab = 1"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 1 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 1 ? {fontWeight: 700} : {}"
                >
                  노코드 워크플로우
                </div>
              </div>
              <!-- 데이터 표준화 -->
              <div @click="section1_tab = 2"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 2 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 2 ? {fontWeight: 700} : {}"
                >
                  데이터 표준화
                </div>
              </div>
              <!-- 문서 자동 생성 -->
              <div @click="section1_tab = 3"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 3 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 3 ? {fontWeight: 700} : {}"
                >
                  문서 자동 생성
                </div>
              </div>
              <!-- 데이터 시각화 -->
              <div @click="section1_tab = 4"
                class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
                style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; width: calc(100%); height: 100%; border-bottom: 1px solid #ffffff; padding-bottom: 2px; cursor: pointer"
                :style="section1_tab === 4 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
              >
                <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                  :style="section1_tab === 4 ? {fontWeight: 700} : {}"
                >
                  데이터 시각화
                </div>
              </div>
            </div>
            <!-- 탭 내용 -->
            <div style="width: 100%">
              <!-- 비즈니스 프로세스 -->
              <div v-show="section1_tab === 0" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                  복잡한 업무 흐름을 변경없이 그대로 자동화합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab1_img.svg" style="width: 100%">
              </div>
              <!-- 노코드 워크플로우 -->
              <div v-show="section1_tab === 1" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                  데이터 처리부터 AI Agent까지, 드래그 & 드롭 모듈로 빠르게 구축하고 수정하세요
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab2_img.svg" style="width: 100%">
              </div>
              <!-- 데이터 표준화 -->
              <div v-show="section1_tab === 2" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                  분산된 데이터를 사람이 쉽게 인식하도록 표준화하여, 의사결정에만 집중하도록 합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab3_img.svg" style="width: 100%">
              </div>
              <!-- 문서 자동 생성 -->
              <div v-show="section1_tab === 3" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                  데이터에 기업 고유의 양식을 적용하여 문서를 자동으로 생성합니다
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab4_img.svg" style="width: 100%">
              </div>
              <!-- 데이터 시각화 -->
              <div v-show="section1_tab === 4" style="width: 100%">
                <!-- tab title -->
                <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                  복잡한 설정 없이 영역 지정만으로 인사이트 대시보드를 완성하세요
                </div>
                <!-- img -->
                <img src="@/assets/home_section1/section1_tab5_img.svg" style="width: 100%">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- section 1 (show-over-320px-under-768px) -->
      <div class="show-over-320px-under-768px section-1" style="width: 100%; padding: 100px 0px 40px">
        <div class="d-flex flex-column align-center">
          <!-- section title -->
          <div style="width: calc(100% - calc(16px * 2)); text-align: center; font-size: 32px; font-weight: 300; line-height: 135%; letter-spacing: -0.02em; color: #ffffff">
            작업은 시스템이, 결정은 사람이 하는
          </div>
          <div style="width: calc(100% - calc(16px * 2)); text-align: center; font-size: 32px; font-weight: 700; line-height: 135%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 32px">
            AI-Powered Workflow Automation
          </div>
          <!-- 문의하기 버튼 -->
          <div @click="openGoogleForm()" :style="{marginBottom: '80px'}"
            class="hover-bg-color-important d-flex align-center justify-center"
            style="--hover-bg-color: #EB3A00; height: 50px; width: calc(100% - calc(16px * 2)); padding: 0px 36px; background-color: #FF6A39; border-radius: 999px; cursor: pointer"
          >
            <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
              문의하기
            </div>
          </div>
          <!-- 탭 - 비즈니스 프로세스, 노코드 워크플로우, 데이터 표준화, 문서 자동 생성, 데이터 시각화 -->
          <div class="d-flex hide-scroll" style="width: calc(100% - calc(16px * 2)); height: 56px; border-bottom: 1px solid #ffffff; overflow: auto hidden">
            <!-- 비즈니스 프로세스 -->
            <div @click="section1_tab = 0"
              class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
              style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; min-width: fit-content; height: 100%; border-bottom: 0px solid #ffffff; padding: 0px 14px 2px; cursor: pointer"
              :style="section1_tab === 0 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
            >
              <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                :style="section1_tab === 0 ? {fontWeight: 700} : {}"
              >
                비즈니스 프로세스
              </div>
            </div>
            <!-- 노코드 워크플로우 -->
            <div @click="section1_tab = 1"
              class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
              style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; min-width: fit-content; height: 100%; border-bottom: 0px solid #ffffff; padding: 0px 14px 2px; cursor: pointer"
              :style="section1_tab === 1 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
            >
              <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                :style="section1_tab === 1 ? {fontWeight: 700} : {}"
              >
                노코드 워크플로우
              </div>
            </div>
            <!-- 데이터 표준화 -->
            <div @click="section1_tab = 2"
              class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
              style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; min-width: fit-content; height: 100%; border-bottom: 0px solid #ffffff; padding: 0px 14px 2px; cursor: pointer"
              :style="section1_tab === 2 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
            >
              <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                :style="section1_tab === 2 ? {fontWeight: 700} : {}"
              >
                데이터 표준화
              </div>
            </div>
            <!-- 문서 자동 생성 -->
            <div @click="section1_tab = 3"
              class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
              style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; min-width: fit-content; height: 100%; border-bottom: 0px solid #ffffff; padding: 0px 14px 2px; cursor: pointer"
              :style="section1_tab === 3 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
            >
              <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                :style="section1_tab === 3 ? {fontWeight: 700} : {}"
              >
                문서 자동 생성
              </div>
            </div>
            <!-- 데이터 시각화 -->
            <div @click="section1_tab = 4"
              class="hover-border-width-important hover-border-color-important hover-padding-bottom-important d-flex align-center justify-center"
              style="--hover-border-width: 3px; --hover-border-color: #ffffff; --hover-padding-bottom: 0px; min-width: fit-content; height: 100%; border-bottom: 0px solid #ffffff; padding: 0px 14px 2px; cursor: pointer"
              :style="section1_tab === 4 ? {borderBottom: '3px solid #ffffff', paddingBottom: '0px !important'} : {}"
            >
              <div style="font-size: 17px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #ffffff"
                :style="section1_tab === 4 ? {fontWeight: 700} : {}"
              >
                데이터 시각화
              </div>
            </div>
          </div>
          <!-- 탭 내용 -->
          <div style="width: calc(100% - calc(16px * 2))">
            <!-- 비즈니스 프로세스 -->
            <div v-show="section1_tab === 0" style="width: 100%">
              <!-- tab title -->
              <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                복잡한 업무 흐름을 변경없이 그대로 자동화합니다
              </div>
              <!-- img -->
              <img src="@/assets/home_section1/section1_tab1_img.svg" style="width: 100%">
            </div>
            <!-- 노코드 워크플로우 -->
            <div v-show="section1_tab === 1" style="width: 100%">
              <!-- tab title -->
              <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                데이터 처리부터 AI Agent까지, 드래그 & 드롭 모듈로 빠르게 구축하고 수정하세요
              </div>
              <!-- img -->
              <img src="@/assets/home_section1/section1_tab2_img.svg" style="width: 100%">
            </div>
            <!-- 데이터 표준화 -->
            <div v-show="section1_tab === 2" style="width: 100%">
              <!-- tab title -->
              <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                분산된 데이터를 사람이 쉽게 인식하도록 표준화하여, 의사결정에만 집중하도록 합니다
              </div>
              <!-- img -->
              <img src="@/assets/home_section1/section1_tab3_img.svg" style="width: 100%">
            </div>
            <!-- 문서 자동 생성 -->
            <div v-show="section1_tab === 3" style="width: 100%">
              <!-- tab title -->
              <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                데이터에 기업 고유의 양식을 적용하여 문서를 자동으로 생성합니다
              </div>
              <!-- img -->
              <img src="@/assets/home_section1/section1_tab4_img.svg" style="width: 100%">
            </div>
            <!-- 데이터 시각화 -->
            <div v-show="section1_tab === 4" style="width: 100%">
              <!-- tab title -->
              <div style="font-size: 17px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin: 16px 0px">
                복잡한 설정 없이 영역 지정만으로 인사이트 대시보드를 완성하세요
              </div>
              <!-- img -->
              <img src="@/assets/home_section1/section1_tab5_img.svg" style="width: 100%">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- section 2 - partner -->
    <vue-marquee-slider class="show-over-320px"
      id="marquee-slider"
      :speed="90000"
      :width="140"
      :space="34"
      style="width: 100%"
    >
      <div v-for="(partner, partner_idx) in partner_list" :key="partner_idx" class="d-flex align-center" style="height: 82px">
        <img :src="require(`@/assets/partner/${partner.src}`)">
      </div>
    </vue-marquee-slider>

    <!-- section 3 - Our Mission -->
    <div class="section-3-wrapper">
      <!-- show-over-1537px -->
      <div class="show-over-1537px" style="width: 100%; padding: 180px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex align-center" style="width: 1536px; gap: 150px">
            <!-- content -->
            <div class="d-flex flex-column justify-center" style="flex: 1">
              <!-- title -->
              <div style="font-size: 52px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 56px">
                Our Mission
              </div>
              <!-- sub -->
              <div style="font-size: 22px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                우리는 변화하는 비즈니스 프로세스를 실시간으로 반영하여 사람들이 실제로 활용할 수 있는 자동화 플랫폼을 만듭니다.
              </div>
              <!-- sub -->
              <div style="font-size: 22px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                단순한 자동화가 아니라, 안정적이고 일관된 의사결정을 지원하는 것이 우리의 목표입니다.
              </div>
              <!-- sub -->
              <div style="font-size: 22px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                우리는 기업이 더 빠르고 정확한 판단으로 본질적 성장과 지속가능한 성과를 이루도록 돕습니다.
              </div>
            </div>
            <!-- img -->
            <img src="@/assets/home_section3/section3_img.svg" style="width: 730px">
          </div>
        </div>
      </div>
      <!-- show-over-1281px-under-1536px -->
      <div class="show-over-1281px-under-1536px" style="width: 100%; padding: 140px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex align-center" style="width: 1181px; gap: 90px">
            <!-- content -->
            <div class="d-flex flex-column justify-center" style="flex: 1">
              <!-- title -->
              <div style="font-size: 46px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 56px">
                Our Mission
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                우리는 변화하는 비즈니스 프로세스를 실시간으로 반영하여 사람들이 실제로 활용할 수 있는 자동화 플랫폼을 만듭니다.
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                단순한 자동화가 아니라, 안정적이고 일관된 의사결정을 지원하는 것이 우리의 목표입니다.
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                우리는 기업이 더 빠르고 정확한 판단으로 본질적 성장과 지속가능한 성과를 이루도록 돕습니다.
              </div>
            </div>
            <!-- img -->
            <img src="@/assets/home_section3/section3_img.svg" style="width: 614px">
          </div>
        </div>
      </div>
      <!-- show-over-1025px-under-1280px -->
      <div class="show-over-1025px-under-1280px" style="width: 100%; padding: 140px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex align-center" style="width: 925px; gap: 48px">
            <!-- content -->
            <div class="d-flex flex-column justify-center" style="flex: 1">
              <!-- title -->
              <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 56px">
                Our Mission
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                우리는 변화하는 비즈니스 프로세스를 실시간으로 반영하여 사람들이 실제로 활용할 수 있는 자동화 플랫폼을 만듭니다.
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                단순한 자동화가 아니라, 안정적이고 일관된 의사결정을 지원하는 것이 우리의 목표입니다.
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                우리는 기업이 더 빠르고 정확한 판단으로 본질적 성장과 지속가능한 성과를 이루도록 돕습니다.
              </div>
            </div>
            <!-- img -->
            <img src="@/assets/home_section3/section3_img.svg" style="width: 460px">
          </div>
        </div>
      </div>
      <!-- show-over-769px-under-1024px -->
      <div class="show-over-769px-under-1024px" style="width: 100%; padding: 100px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex flex-column align-center" style="width: 709px; gap: 48px">
            <!-- img -->
            <img src="@/assets/home_section3/section3_img.svg" style="width: 100%">
            <!-- content -->
            <div class="d-flex flex-column justify-center" style="width: 100%">
              <!-- title -->
              <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 32px">
                Our Mission
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                우리는 변화하는 비즈니스 프로세스를 실시간으로 반영하여 사람들이 실제로 활용할 수 있는 자동화 플랫폼을 만듭니다.
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                단순한 자동화가 아니라, 안정적이고 일관된 의사결정을 지원하는 것이 우리의 목표입니다.
              </div>
              <!-- sub -->
              <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                우리는 기업이 더 빠르고 정확한 판단으로 본질적 성장과 지속가능한 성과를 이루도록 돕습니다.
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-320px-under-768px -->
      <div class="show-over-320px-under-768px" style="width: 100%; padding: 100px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="d-flex flex-column align-center" style="width: calc(100% - calc(16px * 2)); gap: 48px">
            <!-- img -->
            <img src="@/assets/home_section3/section3_img.svg" style="width: 100%">
            <!-- content -->
            <div class="d-flex flex-column justify-center" style="width: 100%">
              <!-- title -->
              <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 32px">
                Our Mission
              </div>
              <!-- sub -->
              <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                우리는 변화하는 비즈니스 프로세스를 실시간으로 반영하여 사람들이 실제로 활용할 수 있는 자동화 플랫폼을 만듭니다.
              </div>
              <!-- sub -->
              <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 14px">
                단순한 자동화가 아니라, 안정적이고 일관된 의사결정을 지원하는 것이 우리의 목표입니다.
              </div>
              <!-- sub -->
              <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                우리는 기업이 더 빠르고 정확한 판단으로 본질적 성장과 지속가능한 성과를 이루도록 돕습니다.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- section 4 - 업무를 더 간단히, 의사결정을 더 빠르게 -->
    <div class="section-4-wrapper">
      <!-- show-over-1537px -->
      <div class="show-over-1537px" style="width: 100%; padding: 100px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1536px">
            <!-- title -->
            <div style="font-size: 40px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 48px">
              업무를 더 간단히, 의사결정을 더 빠르게
            </div>
            <!-- box wrapper 1 -->
            <div class="d-flex" style="width: 100%; height: 460px; gap: 20px; margin-bottom: 20px">
              <!-- box 1 -->
              <div class="section-4-box" style="width: calc(100% / 3); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img1.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 64px 44px 44px"
                >
                  <div style="font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    HITL 기반 100% 정밀 검증 데이터 파이프라인
                  </div>
                  <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    AI 파서와 Human-in-the-Loop 검증 프로세스를 결합해 데이터 품질을 완전하게 보장할 수 있는 하이브리드 엔진을 운용합니다.
                  </div>
                </div>
              </div>
              <!-- box 2 -->
              <div class="section-4-box" style="width: calc(100% / 3); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img2.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 64px 44px 44px"
                >
                  <div style="font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    전문 개발지식이 필요없는 노코드 워크플로우 엔진
                  </div>
                  <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    이벤트 드리븐(event-driven) 아키텍처로 복잡한 비즈니스 로직을 코드 없이 설계하고 자동화합니다.
                  </div>
                </div>
              </div>
              <!-- box 3 -->
              <div class="section-4-box" style="width: calc(100% / 3); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img3.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 64px 44px 44px"
                >
                  <div style="font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    복잡한 양식도 그대로 반영하는 문서 자동 생성 모듈
                  </div>
                  <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    정형화된 DB에 템플릿 엔진을 매핑해 회사 양식과 동일한 문서를(보고서, 계약서 등) 자동 생성합니다.
                  </div>
                </div>
              </div>
            </div>
            <!-- box wrapper 2 -->
            <div class="d-flex" style="width: 100%; height: 460px; gap: 20px">
              <!-- box 4 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img4.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 64px 44px 44px"
                >
                  <div style="font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    인터랙티브 BI 레벨의 자체 인사이트 시각화 Tool
                  </div>
                  <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    실시간 데이터 모델링과 시각화 Tool을 이용해 경영 현황과 핵심 지표를 직관적으로 표현합니다.
                  </div>
                </div>
              </div>
              <!-- box 5 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img5.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 64px 44px 44px"
                >
                  <div style="font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    엔터프라이즈 데이터 거버넌스 & 접근 제어 레이어
                  </div>
                  <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    워크플로우, 권한, 감사 로그를 중앙집중형 레이어에서 관리하며 보안성과 투명성을 강화합니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1281px-under-1536px -->
      <div class="show-over-1281px-under-1536px" style="width: 100%; padding: 100px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1181px">
            <!-- title -->
            <div style="font-size: 40px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 48px">
              업무를 더 간단히, 의사결정을 더 빠르게
            </div>
            <!-- box wrapper 1 -->
            <div class="d-flex" style="width: 100%; height: 420px; gap: 20px; margin-bottom: 20px">
              <!-- box 1 -->
              <div class="section-4-box" style="width: calc(100% / 3); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img1.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    HITL 기반 100% 정밀 검증 데이터 파이프라인
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    AI 파서와 Human-in-the-Loop 검증 프로세스를 결합해 데이터 품질을 완전하게 보장할 수 있는 하이브리드 엔진을 운용합니다.
                  </div>
                </div>
              </div>
              <!-- box 2 -->
              <div class="section-4-box" style="width: calc(100% / 3); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img2.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    전문 개발지식이 필요없는 노코드 워크플로우 엔진
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    이벤트 드리븐(event-driven) 아키텍처로 복잡한 비즈니스 로직을 코드 없이 설계하고 자동화합니다.
                  </div>
                </div>
              </div>
              <!-- box 3 -->
              <div class="section-4-box" style="width: calc(100% / 3); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img3.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    복잡한 양식도 그대로 반영하는 문서 자동 생성 모듈
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    정형화된 DB에 템플릿 엔진을 매핑해 회사 양식과 동일한 문서를(보고서, 계약서 등) 자동 생성합니다.
                  </div>
                </div>
              </div>
            </div>
            <!-- box wrapper 2 -->
            <div class="d-flex" style="width: 100%; height: 420px; gap: 20px">
              <!-- box 4 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img4.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    인터랙티브 BI 레벨의 자체 인사이트 시각화 Tool
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    실시간 데이터 모델링과 시각화 Tool을 이용해 경영 현황과 핵심 지표를 직관적으로 표현합니다.
                  </div>
                </div>
              </div>
              <!-- box 5 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img5.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    엔터프라이즈 데이터 거버넌스 & 접근 제어 레이어
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    워크플로우, 권한, 감사 로그를 중앙집중형 레이어에서 관리하며 보안성과 투명성을 강화합니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1025px-under-1280px -->
      <div class="show-over-1025px-under-1280px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 925px">
            <!-- title -->
            <div style="font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 48px">
              업무를 더 간단히, 의사결정을 더 빠르게
            </div>
            <!-- box wrapper 1 -->
            <div class="d-flex" style="width: 100%; height: 420px; gap: 20px; margin-bottom: 20px">
              <!-- box 1 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img1.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    HITL 기반 100% 정밀 검증 데이터 파이프라인
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    AI 파서와 Human-in-the-Loop 검증 프로세스를 결합해 데이터 품질을 완전하게 보장할 수 있는 하이브리드 엔진을 운용합니다.
                  </div>
                </div>
              </div>
              <!-- box 2 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img2.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    전문 개발지식이 필요없는 노코드 워크플로우 엔진
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    이벤트 드리븐(event-driven) 아키텍처로 복잡한 비즈니스 로직을 코드 없이 설계하고 자동화합니다.
                  </div>
                </div>
              </div>
            </div>
            <!-- box wrapper 2 -->
            <div class="d-flex" style="width: 100%; height: 420px; gap: 20px; margin-bottom: 20px">
              <!-- box 3 -->
              <div class="section-4-box" style="width: calc(100% / 1); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img3.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    복잡한 양식도 그대로 반영하는 문서 자동 생성 모듈
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    정형화된 DB에 템플릿 엔진을 매핑해 회사 양식과 동일한 문서를(보고서, 계약서 등) 자동 생성합니다.
                  </div>
                </div>
              </div>
            </div>
            <!-- box wrapper 3 -->
            <div class="d-flex" style="width: 100%; height: 420px; gap: 20px">
              <!-- box 4 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img4.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    인터랙티브 BI 레벨의 자체 인사이트 시각화 Tool
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    실시간 데이터 모델링과 시각화 Tool을 이용해 경영 현황과 핵심 지표를 직관적으로 표현합니다.
                  </div>
                </div>
              </div>
              <!-- box 5 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img5.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 56px 38px 44px"
                >
                  <div style="font-size: 26px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    엔터프라이즈 데이터 거버넌스 & 접근 제어 레이어
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    워크플로우, 권한, 감사 로그를 중앙집중형 레이어에서 관리하며 보안성과 투명성을 강화합니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-769px-under-1024px -->
      <div class="show-over-769px-under-1024px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 709px">
            <!-- title -->
            <div style="font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 48px">
              업무를 더 간단히, 의사결정을 더 빠르게
            </div>
            <!-- box wrapper 1 -->
            <div class="d-flex" style="width: 100%; height: 380px; gap: 12px; margin-bottom: 12px">
              <!-- box 1 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img1.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    HITL 기반 100% 정밀 검증 데이터 파이프라인
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    AI 파서와 Human-in-the-Loop 검증 프로세스를 결합해 데이터 품질을 완전하게 보장할 수 있는 하이브리드 엔진을 운용합니다.
                  </div>
                </div>
              </div>
              <!-- box 2 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img2.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    전문 개발지식이 필요없는 노코드 워크플로우 엔진
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    이벤트 드리븐(event-driven) 아키텍처로 복잡한 비즈니스 로직을 코드 없이 설계하고 자동화합니다.
                  </div>
                </div>
              </div>
            </div>
            <!-- box wrapper 2 -->
            <div class="d-flex" style="width: 100%; height: 380px; gap: 12px; margin-bottom: 12px">
              <!-- box 3 -->
              <div class="section-4-box" style="width: calc(100% / 1); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img3.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    복잡한 양식도 그대로 반영하는 문서 자동 생성 모듈
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    정형화된 DB에 템플릿 엔진을 매핑해 회사 양식과 동일한 문서를(보고서, 계약서 등) 자동 생성합니다.
                  </div>
                </div>
              </div>
            </div>
            <!-- box wrapper 3 -->
            <div class="d-flex" style="width: 100%; height: 380px; gap: 12px">
              <!-- box 4 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img4.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    인터랙티브 BI 레벨의 자체 인사이트 시각화 Tool
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    실시간 데이터 모델링과 시각화 Tool을 이용해 경영 현황과 핵심 지표를 직관적으로 표현합니다.
                  </div>
                </div>
              </div>
              <!-- box 5 -->
              <div class="section-4-box" style="width: calc(100% / 2); height: 100%; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img5.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    엔터프라이즈 데이터 거버넌스 & 접근 제어 레이어
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    워크플로우, 권한, 감사 로그를 중앙집중형 레이어에서 관리하며 보안성과 투명성을 강화합니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-320px-under-768px -->
      <div class="show-over-320px-under-768px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: calc(100% - calc(16px * 2))">
            <!-- title -->
            <div style="font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 48px">
              업무를 더 간단히, <br> 의사결정을 더 빠르게
            </div>
            <!-- box wrapper -->
            <div class="d-flex flex-column" style="width: 100%; gap: 12px">
              <!-- box 1 -->
              <div class="section-4-box" style="width: calc(100% / 1); height: 300px; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img1.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    HITL 기반 100% 정밀 검증 데이터 파이프라인
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    AI 파서와 Human-in-the-Loop 검증 프로세스를 결합해 데이터 품질을 완전하게 보장할 수 있는 하이브리드 엔진을 운용합니다.
                  </div>
                </div>
              </div>
              <!-- box 2 -->
              <div class="section-4-box" style="width: calc(100% / 1); height: 300px; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img2.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    전문 개발지식이 필요없는 노코드 워크플로우 엔진
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    이벤트 드리븐(event-driven) 아키텍처로 복잡한 비즈니스 로직을 코드 없이 설계하고 자동화합니다.
                  </div>
                </div>
              </div>
              <!-- box 3 -->
              <div class="section-4-box" style="width: calc(100% / 1); height: 300px; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img3.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    복잡한 양식도 그대로 반영하는 문서 자동 생성 모듈
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    정형화된 DB에 템플릿 엔진을 매핑해 회사 양식과 동일한 문서를(보고서, 계약서 등) 자동 생성합니다.
                  </div>
                </div>
              </div>
              <!-- box 4 -->
              <div class="section-4-box" style="width: calc(100% / 1); height: 300px; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img4.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    인터랙티브 BI 레벨의 자체 인사이트 시각화 Tool
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    실시간 데이터 모델링과 시각화 Tool을 이용해 경영 현황과 핵심 지표를 직관적으로 표현합니다.
                  </div>
                </div>
              </div>
              <!-- box 5 -->
              <div class="section-4-box" style="width: calc(100% / 1); height: 300px; border-radius: 8px; overflow: hidden; position: relative">
                <!-- img -->
                <img src="@/assets/home_section4/section4_img5.svg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 50%">
                <!-- overlay, text -->
                <div class="d-flex flex-column justify-space-between"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #000000B2; padding: 44px 30px 34px"
                >
                  <div style="font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #ffffff">
                    엔터프라이즈 데이터 거버넌스 & 접근 제어 레이어
                  </div>
                  <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #ffffff">
                    워크플로우, 권한, 감사 로그를 중앙집중형 레이어에서 관리하며 보안성과 투명성을 강화합니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- section 5 - Business Area -->
    <div class="section-5-wrapper">
      <!-- show-over-1537px -->
      <div class="show-over-1537px" style="width: 100%; padding: 80px 0px 80px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1536px">
            <!-- title -->
            <div style="font-size: 52px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 80px">
              Business Area
            </div>
            <!-- img, text content -->
            <div class="d-flex align-center" style="gap: 150px; margin-bottom: 100px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img1_1.svg" style="width: 730px">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="flex: 1">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 40px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 24px">
                  업무자동화 플랫폼
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 22px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  데이터 수집, 통합 · 표준화, 문서 생성과 시각화까지 반복적이고 복잡한 작업을 자동으로 처리해 기업의 업무 부담을 획기적으로 줄입니다. <br>
                  특히 데이터 형식과 항목이 바뀌어도 실시간으로 반영할 수 있어, 끊임없이 변화하는 비즈니스 환경에서도 안정적인 자동화를 보장합니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 48px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 수집 자동화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 통합 표준화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      자동 스케쥴링
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      문서 양식 적용
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      통계 분석
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 시각화
                    </div>
                  </div>
                </div>
                <!-- Re:Column 바로가기 버튼 -->
                <div @click="openRecolumn()"
                  class="hover-bg-color hover-child-color-important d-flex align-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: fit-content; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    Re:Column 바로가기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
            <!-- img, text content -->
            <div class="d-flex align-center" style="gap: 150px; margin-bottom: 0px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img2_1.svg" style="width: 730px">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="flex: 1">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 40px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 24px">
                  인공지능 솔루션
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 22px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  Cutting-edge AI 기술을 활용해 방대한 데이터를 자동으로 검색 · 추출 · 분석하고, 누구나 자연스럽게 질의하고 활용할 수 있는 환경을 제공합니다. <br>
                  다양한 형태의 정보를 표준화된 형태로 정제하여, 기업이 가진 데이터를 실제 업무에서 활용할 수 있는 자산으로 만듭니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 48px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      비정형 데이터 추출
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 검색/추출 (RAG)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      자연어 질의응답 (LLM)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      시각화 및 보고서 생성
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      Text-to-SQL
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      AI Agent
                    </div>
                  </div>
                </div>
                <!-- 기업용 AI 솔루션 문의하기 버튼 -->
                <div @click="openGoogleForm()"
                  class="hover-bg-color hover-child-color-important d-flex align-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: fit-content; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    기업용 AI 솔루션 문의하기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1281px-under-1536px -->
      <div class="show-over-1281px-under-1536px" style="width: 100%; padding: 80px 0px 80px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1181px">
            <!-- title -->
            <div style="font-size: 46px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 80px">
              Business Area
            </div>
            <!-- img, text content -->
            <div class="d-flex align-center" style="gap: 90px; margin-bottom: 100px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img1_2.svg" style="width: 614px">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="flex: 1">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 24px">
                  업무자동화 플랫폼
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  데이터 수집, 통합 · 표준화, 문서 생성과 시각화까지 반복적이고 복잡한 작업을 자동으로 처리해 기업의 업무 부담을 획기적으로 줄입니다. <br>
                  특히 데이터 형식과 항목이 바뀌어도 실시간으로 반영할 수 있어, 끊임없이 변화하는 비즈니스 환경에서도 안정적인 자동화를 보장합니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 40px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 수집 자동화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 통합 표준화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      자동 스케쥴링
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      문서 양식 적용
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      통계 분석
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 시각화
                    </div>
                  </div>
                </div>
                <!-- Re:Column 바로가기 버튼 -->
                <div @click="openRecolumn()"
                  class="hover-bg-color hover-child-color-important d-flex align-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: fit-content; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    Re:Column 바로가기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
            <!-- img, text content -->
            <div class="d-flex align-center" style="gap: 90px; margin-bottom: 0px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img2_2.svg" style="width: 614px">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="flex: 1">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 32px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 24px">
                  인공지능 솔루션
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  Cutting-edge AI 기술을 활용해 방대한 데이터를 자동으로 검색 · 추출 · 분석하고, 누구나 자연스럽게 질의하고 활용할 수 있는 환경을 제공합니다. <br>
                  다양한 형태의 정보를 표준화된 형태로 정제하여, 기업이 가진 데이터를 실제 업무에서 활용할 수 있는 자산으로 만듭니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 40px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      비정형 데이터 추출
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 검색/추출 (RAG)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      자연어 질의응답 (LLM)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      시각화 및 보고서 생성
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      Text-to-SQL
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      AI Agent
                    </div>
                  </div>
                </div>
                <!-- 기업용 AI 솔루션 문의하기 버튼 -->
                <div @click="openGoogleForm()"
                  class="hover-bg-color hover-child-color-important d-flex align-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: fit-content; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    기업용 AI 솔루션 문의하기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1025px-under-1280px -->
      <div class="show-over-1025px-under-1280px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 925px">
            <!-- title -->
            <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 60px">
              Business Area
            </div>
            <!-- img, text content -->
            <div class="d-flex flex-column" style="gap: 48px; margin-bottom: 100px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img1_3.svg" style="width: 100%">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="width: 100%">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 28px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 24px">
                  업무자동화 플랫폼
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  데이터 수집, 통합 · 표준화, 문서 생성과 시각화까지 반복적이고 복잡한 작업을 자동으로 처리해 기업의 업무 부담을 획기적으로 줄입니다. <br>
                  특히 데이터 형식과 항목이 바뀌어도 실시간으로 반영할 수 있어, 끊임없이 변화하는 비즈니스 환경에서도 안정적인 자동화를 보장합니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 40px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 수집 자동화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 통합 표준화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      자동 스케쥴링
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      문서 양식 적용
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      통계 분석
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 시각화
                    </div>
                  </div>
                </div>
                <!-- Re:Column 바로가기 버튼 -->
                <div @click="openRecolumn()"
                  class="hover-bg-color hover-child-color-important d-flex align-center justify-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: 100%; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    Re:Column 바로가기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
            <!-- img, text content -->
            <div class="d-flex flex-column" style="gap: 48px; margin-bottom: 0px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img2_3.svg" style="width: 100%">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="width: 100%">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 28px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 24px">
                  인공지능 솔루션
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  Cutting-edge AI 기술을 활용해 방대한 데이터를 자동으로 검색 · 추출 · 분석하고, 누구나 자연스럽게 질의하고 활용할 수 있는 환경을 제공합니다.
                  다양한 형태의 정보를 표준화된 형태로 정제하여, 기업이 가진 데이터를 실제 업무에서 활용할 수 있는 자산으로 만듭니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 40px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      비정형 데이터 추출
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 검색/추출 (RAG)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      자연어 질의응답 (LLM)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      시각화 및 보고서 생성
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      Text-to-SQL
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      AI Agent
                    </div>
                  </div>
                </div>
                <!-- 기업용 AI 솔루션 문의하기 버튼 -->
                <div @click="openGoogleForm()"
                  class="hover-bg-color hover-child-color-important d-flex align-center justify-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: 100%; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    기업용 AI 솔루션 문의하기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-769px-under-1024px -->
      <div class="show-over-769px-under-1024px" style="width: 100%; padding: 80px 0px 80px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 709px">
            <!-- title -->
            <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 60px">
              Business Area
            </div>
            <!-- img, text content -->
            <div class="d-flex flex-column" style="gap: 32px; margin-bottom: 100px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img1_4.svg" style="width: 100%">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="width: 100%">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 28px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 18px">
                  업무자동화 플랫폼
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  데이터 수집, 통합 · 표준화, 문서 생성과 시각화까지 반복적이고 복잡한 작업을 자동으로 처리해 기업의 업무 부담을 획기적으로 줄입니다. <br>
                  특히 데이터 형식과 항목이 바뀌어도 실시간으로 반영할 수 있어, 끊임없이 변화하는 비즈니스 환경에서도 안정적인 자동화를 보장합니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 40px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 수집 자동화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 통합 표준화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      자동 스케쥴링
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      문서 양식 적용
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      통계 분석
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 시각화
                    </div>
                  </div>
                </div>
                <!-- Re:Column 바로가기 버튼 -->
                <div @click="openRecolumn()"
                  class="hover-bg-color hover-child-color-important d-flex align-center justify-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: 100%; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    Re:Column 바로가기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
            <!-- img, text content -->
            <div class="d-flex flex-column" style="gap: 32px; margin-bottom: 0px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img2_4.svg" style="width: 100%">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="width: 100%">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 28px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 18px">
                  인공지능 솔루션
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  Cutting-edge AI 기술을 활용해 방대한 데이터를 자동으로 검색 · 추출 · 분석하고, 누구나 자연스럽게 질의하고 활용할 수 있는 환경을 제공합니다.
                  다양한 형태의 정보를 표준화된 형태로 정제하여, 기업이 가진 데이터를 실제 업무에서 활용할 수 있는 자산으로 만듭니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 40px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      비정형 데이터 추출
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      데이터 검색/추출 (RAG)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      자연어 질의응답 (LLM)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      시각화 및 보고서 생성
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      Text-to-SQL
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 3); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.04em; color: #0D0E17">
                      AI Agent
                    </div>
                  </div>
                </div>
                <!-- 기업용 AI 솔루션 문의하기 버튼 -->
                <div @click="openGoogleForm()"
                  class="hover-bg-color hover-child-color-important d-flex align-center justify-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: 100%; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    기업용 AI 솔루션 문의하기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-320px-under-768px -->
      <div class="show-over-320px-under-768px" style="width: 100%; padding: 80px 0px 80px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: calc(100% - calc(16px * 2))">
            <!-- title -->
            <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 60px">
              Business Area
            </div>
            <!-- img, text content -->
            <div class="d-flex flex-column" style="gap: 32px; margin-bottom: 100px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img1_5.png" style="width: 100%">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="width: 100%">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 28px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 18px">
                  업무자동화 플랫폼
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  데이터 수집, 통합 · 표준화, 문서 생성과 시각화까지 반복적이고 복잡한 작업을 자동으로 처리해 기업의 업무 부담을 획기적으로 줄입니다. <br>
                  특히 데이터 형식과 항목이 바뀌어도 실시간으로 반영할 수 있어, 끊임없이 변화하는 비즈니스 환경에서도 안정적인 자동화를 보장합니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 40px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      데이터 수집 자동화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      데이터 통합 표준화
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      자동 스케쥴링
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      문서 양식 적용
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      통계 분석
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      데이터 시각화
                    </div>
                  </div>
                </div>
                <!-- Re:Column 바로가기 버튼 -->
                <div @click="openRecolumn()"
                  class="hover-bg-color hover-child-color-important d-flex align-center justify-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: 100%; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    Re:Column 바로가기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
            <!-- img, text content -->
            <div class="d-flex flex-column" style="gap: 32px; margin-bottom: 0px">
              <!-- img -->
              <img src="@/assets/home_section5/section5_img2_5.png" style="width: 100%">
              <!-- content -->
              <div class="d-flex flex-column justify-center" style="width: 100%">
                <!-- title -->
                <div style="padding-left: 4px; font-size: 28px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 18px">
                  인공지능 솔루션
                </div>
                <!-- sub -->
                <div style="padding-left: 4px; font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 28px">
                  Cutting-edge AI 기술을 활용해 방대한 데이터를 자동으로 검색 · 추출 · 분석하고, 누구나 자연스럽게 질의하고 활용할 수 있는 환경을 제공합니다.
                  다양한 형태의 정보를 표준화된 형태로 정제하여, 기업이 가진 데이터를 실제 업무에서 활용할 수 있는 자산으로 만듭니다.
                </div>
                <!-- chips -->
                <div class="d-flex flex-wrap" style="gap: 10px; margin-bottom: 40px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      비정형 데이터 추출
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      데이터 검색/추출 (RAG)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      자연어 질의응답 (LLM)
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      시각화 및 보고서 생성
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      Text-to-SQL
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="width: calc((100% - 20px) / 2); height: 46px; border-radius: 999px; background-color: #F8F9FB">
                    <div style="text-align: center; font-size: 15px; font-weight: 400; line-height: 150%; letter-spacing: -0.06em; color: #0D0E17">
                      AI Agent
                    </div>
                  </div>
                </div>
                <!-- 기업용 AI 솔루션 문의하기 버튼 -->
                <div @click="openGoogleForm()"
                  class="hover-bg-color hover-child-color-important d-flex align-center justify-center"
                  style="--hover-bg-color: #0D0E17; --hover-child-text-color: #ffffff; --hover-child-icon-color: #ffffff; width: 100%; height: 50px; padding: 0px 14px 0px 16px; gap: 6px; border-radius: 8px; border: 1px solid #0D0E17; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    기업용 AI 솔루션 문의하기
                  </div>
                  <v-icon style="font-size: 20px; color: #0D0E17; transition: none">
                    mdi-arrow-top-right
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- section 6 - History -->
    <div class="section-6-wrapper">
      <!-- show-over-1537px -->
      <div class="show-over-1537px" style="width: 100%; padding: 100px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1536px">
            <!-- title -->
            <div style="font-size: 52px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 80px">
              History
            </div>
            <!-- content -->
            <div class="d-flex align-start" style="gap: 60px">
              <!-- left -->
              <div class="d-flex flex-column" style="width: 50%; gap: 40px; position: relative">
                <!-- dot line -->
                <div style="position: absolute; top: 0; left: 7px; width: 1px; height: calc(100% - 10px - 47px); margin: 10px 0px 47px; background-color: #D8DAE9; z-index: 1"></div>
                <!-- 2020 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2020
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      (주)코그콤 법인 설립
                    </div>
                  </div>
                </div>
                <!-- 2021 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2021
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      IBK 1st Lab 협약
                    </div>
                  </div>
                </div>
                <!-- 2022 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2022
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      기업부설연구소 설립
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      Re:Column 플랫폼 출시
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      AI 바우처 공급기업 등록
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      강원대학교 SW중심대학사업단 MOU 체결
                    </div>
                  </div>
                </div>
                <!-- 2023 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2023
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      논문실적 관리 자동화 솔루션 펭귄 AI 출시
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      메르세데스-벤츠코리아 스타트업 아우토반 선정
                    </div>
                  </div>
                </div>
              </div>
              <!-- right -->
              <div class="d-flex flex-column" style="width: 50%; gap: 40px; position: relative">
                <!-- dot line -->
                <div style="position: absolute; top: 0; left: 7px; width: 1px; height: calc(100% - 10px - 85px); margin: 10px 0px 85px; background-color: #D8DAE9; z-index: 1"></div>
                <!-- 2024 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2024
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      펭귄 AI 벤처조달혁신제품 지정
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      S바우처 공급기업 등록
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      메르세데스-벤츠코리아 구매협약서 체결
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      서울AI허브 X 네이버클라우드 오픈이노베이션 선정
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      창업성장기술개발 지원사업 선정
                    </div>
                  </div>
                </div>
                <!-- 2025 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2025
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      INNOBIZ(이노비즈) 인증 취득
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      대검찰청 리컬럼 계약 체결
                    </div>
                    <div style="font-size: 20px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      민관협력 오픈이노베이션 사업 선정
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1281px-under-1536px -->
      <div class="show-over-1281px-under-1536px" style="width: 100%; padding: 100px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1181px">
            <!-- title -->
            <div style="font-size: 46px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 60px">
              History
            </div>
            <!-- content -->
            <div class="d-flex align-start" style="gap: 60px">
              <!-- left -->
              <div class="d-flex flex-column" style="width: 50%; gap: 40px; position: relative">
                <!-- dot line -->
                <div style="position: absolute; top: 0; left: 7px; width: 1px; height: calc(100% - 10px - 47px); margin: 10px 0px 47px; background-color: #D8DAE9; z-index: 1"></div>
                <!-- 2020 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2020
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      (주)코그콤 법인 설립
                    </div>
                  </div>
                </div>
                <!-- 2021 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2021
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      IBK 1st Lab 협약
                    </div>
                  </div>
                </div>
                <!-- 2022 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2022
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      기업부설연구소 설립
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      Re:Column 플랫폼 출시
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      AI 바우처 공급기업 등록
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      강원대학교 SW중심대학사업단 MOU 체결
                    </div>
                  </div>
                </div>
                <!-- 2023 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2023
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      논문실적 관리 자동화 솔루션 펭귄 AI 출시
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      메르세데스-벤츠코리아 스타트업 아우토반 선정
                    </div>
                  </div>
                </div>
              </div>
              <!-- right -->
              <div class="d-flex flex-column" style="width: 50%; gap: 40px; position: relative">
                <!-- dot line -->
                <div style="position: absolute; top: 0; left: 7px; width: 1px; height: calc(100% - 10px - 85px); margin: 10px 0px 85px; background-color: #D8DAE9; z-index: 1"></div>
                <!-- 2024 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2024
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      펭귄 AI 벤처조달혁신제품 지정
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      S바우처 공급기업 등록
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      메르세데스-벤츠코리아 구매협약서 체결
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      서울AI허브 X 네이버클라우드 오픈이노베이션 선정
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      창업성장기술개발 지원사업 선정
                    </div>
                  </div>
                </div>
                <!-- 2025 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 25px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 48px">
                    2025
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      INNOBIZ(이노비즈) 인증 취득
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      대검찰청 리컬럼 계약 체결
                    </div>
                    <div style="font-size: 18px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      민관협력 오픈이노베이션 사업 선정
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1025px-under-1280px -->
      <div class="show-over-1025px-under-1280px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 925px">
            <!-- title -->
            <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 60px">
              History
            </div>
            <!-- content -->
            <div class="d-flex align-start" style="gap: 60px">
              <!-- left -->
              <div class="d-flex flex-column" style="width: 50%; gap: 40px; position: relative">
                <!-- dot line -->
                <div style="position: absolute; top: 0; left: 7px; width: 1px; height: calc(100% - 10px - 47px); margin: 10px 0px 47px; background-color: #D8DAE9; z-index: 1"></div>
                <!-- 2020 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                    2020
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      (주)코그콤 법인 설립
                    </div>
                  </div>
                </div>
                <!-- 2021 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                    2021
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      IBK 1st Lab 협약
                    </div>
                  </div>
                </div>
                <!-- 2022 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                    2022
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      기업부설연구소 설립
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      Re:Column 플랫폼 출시
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      AI 바우처 공급기업 등록
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      강원대학교 SW중심대학사업단 MOU 체결
                    </div>
                  </div>
                </div>
                <!-- 2023 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                    2023
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      논문실적 관리 자동화 솔루션 펭귄 AI 출시
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      메르세데스-벤츠코리아 스타트업 아우토반 선정
                    </div>
                  </div>
                </div>
              </div>
              <!-- right -->
              <div class="d-flex flex-column" style="width: 50%; gap: 40px; position: relative">
                <!-- dot line -->
                <div style="position: absolute; top: 0; left: 7px; width: 1px; height: calc(100% - 10px - 85px); margin: 10px 0px 85px; background-color: #D8DAE9; z-index: 1"></div>
                <!-- 2024 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                    2024
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      펭귄 AI 벤처조달혁신제품 지정
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      S바우처 공급기업 등록
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      메르세데스-벤츠코리아 구매협약서 체결
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      서울AI허브 X 네이버클라우드 오픈이노베이션 선정
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      창업성장기술개발 지원사업 선정
                    </div>
                  </div>
                </div>
                <!-- 2025 -->
                <div class="d-flex align-start" style="z-index: 2">
                  <!-- dot wrapper -->
                  <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                    <!-- dot -->
                    <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                      <!-- inner dot -->
                      <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                    </div>
                  </div>
                  <!-- 년도 -->
                  <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                    2025
                  </div>
                  <!-- 내용 -->
                  <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      INNOBIZ(이노비즈) 인증 취득
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      대검찰청 리컬럼 계약 체결
                    </div>
                    <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                      민관협력 오픈이노베이션 사업 선정
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-769px-under-1024px -->
      <div class="show-over-769px-under-1024px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 709px">
            <!-- title -->
            <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 60px">
              History
            </div>
            <!-- content -->
            <div class="d-flex flex-column" style="width: 100%; gap: 40px; position: relative">
              <!-- dot line -->
              <div style="position: absolute; top: 0; left: 7px; width: 1px; height: calc(100% - 10px - 75px); margin: 10px 0px 75px; background-color: #D8DAE9; z-index: 1"></div>
              <!-- 2020 -->
              <div class="d-flex align-start" style="z-index: 2">
                <!-- dot wrapper -->
                <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                  <!-- dot -->
                  <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                    <!-- inner dot -->
                    <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                </div>
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2020
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    (주)코그콤 법인 설립
                  </div>
                </div>
              </div>
              <!-- 2021 -->
              <div class="d-flex align-start" style="z-index: 2">
                <!-- dot wrapper -->
                <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                  <!-- dot -->
                  <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                    <!-- inner dot -->
                    <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                </div>
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2021
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    IBK 1st Lab 협약
                  </div>
                </div>
              </div>
              <!-- 2022 -->
              <div class="d-flex align-start" style="z-index: 2">
                <!-- dot wrapper -->
                <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                  <!-- dot -->
                  <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                    <!-- inner dot -->
                    <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                </div>
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2022
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    기업부설연구소 설립
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    Re:Column 플랫폼 출시
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    AI 바우처 공급기업 등록
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    강원대학교 SW중심대학사업단 MOU 체결
                  </div>
                </div>
              </div>
              <!-- 2023 -->
              <div class="d-flex align-start" style="z-index: 2">
                <!-- dot wrapper -->
                <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                  <!-- dot -->
                  <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                    <!-- inner dot -->
                    <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                </div>
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2023
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    논문실적 관리 자동화 솔루션 펭귄 AI 출시
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    메르세데스-벤츠코리아 스타트업 아우토반 선정
                  </div>
                </div>
              </div>
              <!-- 2024 -->
              <div class="d-flex align-start" style="z-index: 2">
                <!-- dot wrapper -->
                <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                  <!-- dot -->
                  <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                    <!-- inner dot -->
                    <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                </div>
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2024
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    펭귄 AI 벤처조달혁신제품 지정
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    S바우처 공급기업 등록
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    메르세데스-벤츠코리아 구매협약서 체결
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    서울AI허브 X 네이버클라우드 오픈이노베이션 선정
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    창업성장기술개발 지원사업 선정
                  </div>
                </div>
              </div>
              <!-- 2025 -->
              <div class="d-flex align-start" style="z-index: 2">
                <!-- dot wrapper -->
                <div class="d-flex align-center" style="height: 35px; margin-right: 20px">
                  <!-- dot -->
                  <div class="d-flex align-center justify-center" style="width: 15px; height: 15px; border-radius: 999px; background-color: #0D0E17">
                    <!-- inner dot -->
                    <div class="d-flex align-center justify-center" style="width: 5px; height: 5px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                </div>
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2025
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    INNOBIZ(이노비즈) 인증 취득
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    대검찰청 리컬럼 계약 체결
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    민관협력 오픈이노베이션 사업 선정
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-320px-under-768px -->
      <div class="show-over-320px-under-768px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: calc(100% - calc(16px * 2))">
            <!-- title -->
            <div style="font-size: 36px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 60px">
              History
            </div>
            <!-- content -->
            <div class="d-flex flex-column" style="width: 100%; gap: 40px">
              <!-- 2020 -->
              <div class="d-flex align-start">
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2020
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    (주)코그콤 법인 설립
                  </div>
                </div>
              </div>
              <!-- 2021 -->
              <div class="d-flex align-start">
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2021
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    IBK 1st Lab 협약
                  </div>
                </div>
              </div>
              <!-- 2022 -->
              <div class="d-flex align-start">
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2022
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    기업부설연구소 설립
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    Re:Column 플랫폼 출시
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    AI 바우처 공급기업 등록
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    강원대학교 SW중심대학사업단 MOU 체결
                  </div>
                </div>
              </div>
              <!-- 2023 -->
              <div class="d-flex align-start">
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2023
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    논문실적 관리 자동화 솔루션 펭귄 AI 출시
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    메르세데스-벤츠코리아 스타트업 아우토반 선정
                  </div>
                </div>
              </div>
              <!-- 2024 -->
              <div class="d-flex align-start">
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2024
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    펭귄 AI 벤처조달혁신제품 지정
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    S바우처 공급기업 등록
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    메르세데스-벤츠코리아 구매협약서 체결
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    서울AI허브 X 네이버클라우드 오픈이노베이션 선정
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    창업성장기술개발 지원사업 선정
                  </div>
                </div>
              </div>
              <!-- 2025 -->
              <div class="d-flex align-start">
                <!-- 년도 -->
                <div style="width: 64px; font-size: 22px; font-weight: 700; line-height: 140%; letter-spacing: -0.02em; color: #0D0E17; margin-right: 24px">
                  2025
                </div>
                <!-- 내용 -->
                <div class="d-flex flex-column" style="padding: 2px 0px; gap: 8px">
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    INNOBIZ(이노비즈) 인증 취득
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    대검찰청 리컬럼 계약 체결
                  </div>
                  <div style="font-size: 17px; font-weight: 400; line-height: 150%; letter-spacing: -0.02em; color: #0D0E17">
                    민관협력 오픈이노베이션 사업 선정
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- section 7 - bottom banner -->
    <div class="section-7-wrapper">
      <!-- show-over-1537px -->
      <div class="show-over-1537px" style="width: 100%; padding: 100px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1536px">
            <!-- banner -->
            <div style="width: 100%; height: 355px; overflow: hidden; border-radius: 8px; position: relative">
              <!-- bg img -->
              <img src="@/assets/home_section7/section7_bg_img.jpg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 42%">
              <!-- content -->
              <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; padding: 54px 60px">
                <!-- title -->
                <div style="font-size: 36px; font-weight: 400; line-height: 130%; letter-spacing: -0.02em; color: #ffffff">
                  업무가 반복된다면
                </div>
                <div style="font-size: 36px; font-weight: 700; line-height: 130%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 16px">
                  Re:Column 도입을 고려해보실 때입니다.
                </div>
                <!-- sub -->
                <div style="font-size: 18px; font-weight: 500; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 66px">
                  데이터 수집부터 통합까지 노코드 자동화 엔진이 대신합니다.
                </div>
                <!-- chips / 바로가기 버튼 -->
                <div class="d-flex align-center" style="gap: 10px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #이커머스
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #유통 ∙ 물류
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #제조업
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #공급망
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #공공기관
                    </div>
                  </div>
                  <!-- ... -->
                  <div class="d-flex align-center" style="gap: 4px; padding: 0px 4px">
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                  <v-spacer></v-spacer>
                  <!-- 바로가기 버튼 -->
                  <div @click="openRecolumn()"
                    class="hover-bg-color-important d-flex align-center justify-center"
                    style="--hover-bg-color: #EB3A00; height: 46px; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
                  >
                    <div style="font-size: 18px; font-weight: 700; line-height: 22px; letter-spacing: -0.02em; color: #ffffff">
                      바로가기
                    </div>
                    <v-icon style="font-size: 20px; color: #ffffff">
                      mdi-arrow-right
                    </v-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1281px-under-1536px -->
      <div class="show-over-1281px-under-1536px" style="width: 100%; padding: 100px 0px 100px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1181px">
            <!-- banner -->
            <div style="width: 100%; height: 355px; overflow: hidden; border-radius: 8px; position: relative">
              <!-- bg img -->
              <img src="@/assets/home_section7/section7_bg_img.jpg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 42%">
              <!-- content -->
              <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; padding: 54px 60px">
                <!-- title -->
                <div style="font-size: 36px; font-weight: 400; line-height: 130%; letter-spacing: -0.02em; color: #ffffff">
                  업무가 반복된다면
                </div>
                <div style="font-size: 36px; font-weight: 700; line-height: 130%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 16px">
                  Re:Column 도입을 고려해보실 때입니다.
                </div>
                <!-- sub -->
                <div style="font-size: 18px; font-weight: 500; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 66px">
                  데이터 수집부터 통합까지 노코드 자동화 엔진이 대신합니다.
                </div>
                <!-- chips / 바로가기 버튼 -->
                <div class="d-flex align-center" style="gap: 10px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #이커머스
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #유통 ∙ 물류
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #제조업
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #공급망
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #공공기관
                    </div>
                  </div>
                  <!-- ... -->
                  <div class="d-flex align-center" style="gap: 4px; padding: 0px 4px">
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                  <v-spacer></v-spacer>
                  <!-- 바로가기 버튼 -->
                  <div @click="openRecolumn()"
                    class="hover-bg-color-important d-flex align-center justify-center"
                    style="--hover-bg-color: #EB3A00; height: 46px; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
                  >
                    <div style="font-size: 18px; font-weight: 700; line-height: 22px; letter-spacing: -0.02em; color: #ffffff">
                      바로가기
                    </div>
                    <v-icon style="font-size: 20px; color: #ffffff">
                      mdi-arrow-right
                    </v-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1025px-under-1280px -->
      <div class="show-over-1025px-under-1280px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 925px">
            <!-- banner -->
            <div style="width: 100%; height: 355px; overflow: hidden; border-radius: 8px; position: relative">
              <!-- bg img -->
              <img src="@/assets/home_section7/section7_bg_img.jpg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 42%">
              <!-- content -->
              <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; padding: 54px 60px">
                <!-- title -->
                <div style="font-size: 36px; font-weight: 400; line-height: 130%; letter-spacing: -0.02em; color: #ffffff">
                  업무가 반복된다면
                </div>
                <div style="font-size: 36px; font-weight: 700; line-height: 130%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 16px">
                  Re:Column 도입을 고려해보실 때입니다.
                </div>
                <!-- sub -->
                <div style="font-size: 18px; font-weight: 500; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 66px">
                  데이터 수집부터 통합까지 노코드 자동화 엔진이 대신합니다.
                </div>
                <!-- chips / 바로가기 버튼 -->
                <div class="d-flex align-center" style="gap: 10px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #이커머스
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #유통 ∙ 물류
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #제조업
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #공급망
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #공공기관
                    </div>
                  </div>
                  <!-- ... -->
                  <div class="d-flex align-center" style="gap: 4px; padding: 0px 4px">
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                  <v-spacer></v-spacer>
                  <!-- 바로가기 버튼 -->
                  <div @click="openRecolumn()"
                    class="hover-bg-color-important d-flex align-center justify-center"
                    style="--hover-bg-color: #EB3A00; height: 46px; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
                  >
                    <div style="font-size: 18px; font-weight: 700; line-height: 22px; letter-spacing: -0.02em; color: #ffffff">
                      바로가기
                    </div>
                    <v-icon style="font-size: 20px; color: #ffffff">
                      mdi-arrow-right
                    </v-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-769px-under-1024px -->
      <div class="show-over-769px-under-1024px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 709px">
            <!-- banner -->
            <div style="width: 100%; height: 413px; overflow: hidden; border-radius: 8px; position: relative">
              <!-- bg img -->
              <img src="@/assets/home_section7/section7_bg_img.jpg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 42%">
              <!-- content -->
              <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; padding: 42px 40px">
                <!-- title -->
                <div style="font-size: 28px; font-weight: 400; line-height: 130%; letter-spacing: -0.02em; color: #ffffff">
                  업무가 반복된다면
                </div>
                <div style="font-size: 28px; font-weight: 700; line-height: 130%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 16px">
                  Re:Column 도입을 고려해보실 때입니다.
                </div>
                <!-- sub -->
                <div style="font-size: 18px; font-weight: 500; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 66px">
                  데이터 수집부터 통합까지 노코드 자동화 엔진이 대신합니다.
                </div>
                <!-- chips -->
                <div class="d-flex align-center" style="gap: 10px; margin-bottom: 66px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #이커머스
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #유통 ∙ 물류
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #제조업
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #공급망
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="height: 38px; padding: 0px 18px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 18px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #공공기관
                    </div>
                  </div>
                  <!-- ... -->
                  <div class="d-flex align-center" style="gap: 4px; padding: 0px 4px">
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                </div>
                <!-- 바로가기 버튼 -->
                <div @click="openRecolumn()"
                  class="hover-bg-color-important d-flex align-center justify-center"
                  style="--hover-bg-color: #EB3A00; height: 46px; width: 100%; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
                >
                  <div style="font-size: 18px; font-weight: 700; line-height: 22px; letter-spacing: -0.02em; color: #ffffff">
                    바로가기
                  </div>
                  <v-icon style="font-size: 20px; color: #ffffff">
                    mdi-arrow-right
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-320px-under-768px -->
      <div class="show-over-320px-under-768px" style="width: 100%; padding: 60px 0px 60px">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: calc(100% - calc(0px * 2))">
            <!-- banner -->
            <div style="width: 100%; height: 410px; overflow: hidden; border-radius: 0px; position: relative">
              <!-- bg img -->
              <img src="@/assets/home_section7/section7_bg_img.jpg" style="width: 100%; height: 100%; object-fit: cover; object-position: 50% 42%">
              <!-- content -->
              <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; padding: 42px 16px">
                <!-- title -->
                <div style="text-align: center; font-size: 28px; font-weight: 400; line-height: 130%; letter-spacing: -0.02em; color: #ffffff">
                  업무가 반복된다면
                </div>
                <div style="text-align: center; font-size: 28px; font-weight: 700; line-height: 130%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 16px">
                  Re:Column 도입을 <br> 고려해보실 때입니다.
                </div>
                <!-- sub -->
                <div style="text-align: center; font-size: 18px; font-weight: 500; line-height: 140%; letter-spacing: -0.02em; color: #ffffff; margin-bottom: 48px">
                  데이터 수집부터 통합까지 노코드 자동화 엔진이 대신합니다.
                </div>
                <!-- chips -->
                <div class="d-flex align-center justify-center" style="gap: 8px; margin-bottom: 48px">
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="min-width: max-content; height: 30px; padding: 0px 12px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 14px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #이커머스
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="min-width: max-content; height: 30px; padding: 0px 12px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 14px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #유통 ∙ 물류
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="d-flex align-center justify-center" style="min-width: max-content; height: 30px; padding: 0px 12px; border-radius: 999px; background-color: #ffffff">
                    <div style="font-size: 14px; font-weight: 500; line-height: 22px; color: #0D0E17">
                      #제조업
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="hide-under-400px">
                    <div class="d-flex align-center justify-center" style="min-width: max-content; height: 30px; padding: 0px 12px; border-radius: 999px; background-color: #ffffff">
                      <div style="font-size: 14px; font-weight: 500; line-height: 22px; color: #0D0E17">
                        #공급망
                      </div>
                    </div>
                  </div>
                  <!-- chip -->
                  <div class="hide-under-490px">
                    <div class="d-flex align-center justify-center" style="min-width: max-content; height: 30px; padding: 0px 12px; border-radius: 999px; background-color: #ffffff">
                      <div style="font-size: 14px; font-weight: 500; line-height: 22px; color: #0D0E17">
                        #공공기관
                      </div>
                    </div>
                  </div>
                  <!-- ... -->
                  <div class="d-flex align-center" style="gap: 4px; padding: 0px 4px">
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                    <div style="width: 3px; height: 3px; border-radius: 999px; background-color: #ffffff"></div>
                  </div>
                </div>
                <!-- 바로가기 버튼 -->
                <div @click="openRecolumn()"
                  class="hover-bg-color-important d-flex align-center justify-center"
                  style="--hover-bg-color: #EB3A00; height: 46px; width: 100%; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
                >
                  <div style="font-size: 16px; font-weight: 700; line-height: 22px; letter-spacing: -0.02em; color: #ffffff">
                    바로가기
                  </div>
                  <v-icon style="font-size: 20px; color: #ffffff">
                    mdi-arrow-right
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- footer section -->
    <div class="footer-section">
      <!-- show-over-1537px -->
      <div class="show-over-1537px" style="width: 100%; padding: 56px 0px 64px; background-color: #01010D">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1536px; position: relative">
            <!-- (주)코그콤 -->
            <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #ffffff; margin-bottom: 10px">
              (주)코그콤
            </div>
            <!-- 정보1 -->
            <div class="d-flex align-center" style="margin-bottom: 4px">
              <!-- 대표 정치훈 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                대표 정치훈
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 전화 02-2088-2096 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                전화 02-2088-2096
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 메일 contact@cogcom.kr -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                메일 contact@cogcom.kr
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
              </div>
            </div>
            <!-- 정보2 -->
            <div class="d-flex align-center">
              <!-- 사업자등록번호 378-86-01944 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                사업자등록번호 378-86-01944
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 통신판매업 제2024-서울광진-1178호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                통신판매업 제2024-서울광진-1178호
              </div>
            </div>
            <!-- 우측 하단 버튼 (코그콤 블로그 버튼, 코그콤 링크드인, 리컬럼) -->
            <div class="d-flex align-center" style="position: absolute; bottom: 6px; right: 0px; gap: 6px">
              <!-- 코그콤 블로그 버튼 -->
              <div @click="openBlog()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/blog-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 코그콤 링크드인 버튼 -->
              <div @click="openLinkedIn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/linked-in-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 리컬럼 버튼 -->
              <div @click="openRecolumn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <v-icon style="font-size: 24px; color: #ffffff">
                  mdi-web
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1281px-under-1536px -->
      <div class="show-over-1281px-under-1536px" style="width: 100%; padding: 56px 0px 64px; background-color: #01010D">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 1181px; position: relative">
            <!-- (주)코그콤 -->
            <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #ffffff; margin-bottom: 10px">
              (주)코그콤
            </div>
            <!-- 정보1 -->
            <div class="d-flex align-center" style="margin-bottom: 4px">
              <!-- 대표 정치훈 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                대표 정치훈
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 전화 02-2088-2096 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                전화 02-2088-2096
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 메일 contact@cogcom.kr -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                메일 contact@cogcom.kr
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
              </div>
            </div>
            <!-- 정보2 -->
            <div class="d-flex align-center">
              <!-- 사업자등록번호 378-86-01944 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                사업자등록번호 378-86-01944
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 통신판매업 제2024-서울광진-1178호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                통신판매업 제2024-서울광진-1178호
              </div>
            </div>
            <!-- 우측 하단 버튼 (코그콤 블로그 버튼, 코그콤 링크드인, 리컬럼) -->
            <div class="d-flex align-center" style="position: absolute; bottom: 6px; right: 0px; gap: 6px">
              <!-- 코그콤 블로그 버튼 -->
              <div @click="openBlog()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/blog-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 코그콤 링크드인 버튼 -->
              <div @click="openLinkedIn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/linked-in-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 리컬럼 버튼 -->
              <div @click="openRecolumn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <v-icon style="font-size: 24px; color: #ffffff">
                  mdi-web
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1025px-under-1280px -->
      <div class="show-over-1025px-under-1280px" style="width: 100%; padding: 56px 0px 64px; background-color: #01010D">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 925px; position: relative">
            <!-- (주)코그콤 -->
            <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #ffffff; margin-bottom: 10px">
              (주)코그콤
            </div>
            <!-- 정보1 -->
            <div class="d-flex align-center" style="margin-bottom: 4px">
              <!-- 대표 정치훈 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                대표 정치훈
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 전화 02-2088-2096 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                전화 02-2088-2096
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 메일 contact@cogcom.kr -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                메일 contact@cogcom.kr
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
              </div>
            </div>
            <!-- 정보2 -->
            <div class="d-flex align-center">
              <!-- 사업자등록번호 378-86-01944 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                사업자등록번호 378-86-01944
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 통신판매업 제2024-서울광진-1178호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                통신판매업 제2024-서울광진-1178호
              </div>
            </div>
            <!-- 우측 하단 버튼 (코그콤 블로그 버튼, 코그콤 링크드인, 리컬럼) -->
            <div class="d-flex align-center" style="position: absolute; bottom: 6px; right: 0px; gap: 6px">
              <!-- 코그콤 블로그 버튼 -->
              <div @click="openBlog()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/blog-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 코그콤 링크드인 버튼 -->
              <div @click="openLinkedIn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/linked-in-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 리컬럼 버튼 -->
              <div @click="openRecolumn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <v-icon style="font-size: 24px; color: #ffffff">
                  mdi-web
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-769px-under-1024px -->
      <div class="show-over-769px-under-1024px" style="width: 100%; padding: 56px 0px 64px; background-color: #01010D">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: 709px; position: relative">
            <!-- (주)코그콤 -->
            <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #ffffff; margin-bottom: 10px">
              (주)코그콤
            </div>
            <!-- 정보1 -->
            <div class="d-flex align-center" style="margin-bottom: 4px">
              <!-- 대표 정치훈 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                대표 정치훈
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 전화 02-2088-2096 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                전화 02-2088-2096
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 메일 contact@cogcom.kr -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                메일 contact@cogcom.kr
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
            </div>
            <!-- 정보2 -->
            <div class="d-flex align-center" style="margin-bottom: 4px">
              <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 사업자등록번호 378-86-01944 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                사업자등록번호 378-86-01944
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
            </div>
            <!-- 정보3 -->
            <div class="d-flex align-center">
              <!-- 통신판매업 제2024-서울광진-1178호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                통신판매업 제2024-서울광진-1178호
              </div>
            </div>
            <!-- 우측 하단 버튼 (코그콤 블로그 버튼, 코그콤 링크드인, 리컬럼) -->
            <div class="d-flex align-center" style="position: absolute; bottom: 6px; right: 0px; gap: 6px">
              <!-- 코그콤 블로그 버튼 -->
              <div @click="openBlog()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/blog-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 코그콤 링크드인 버튼 -->
              <div @click="openLinkedIn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/linked-in-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 리컬럼 버튼 -->
              <div @click="openRecolumn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <v-icon style="font-size: 24px; color: #ffffff">
                  mdi-web
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-320px-under-768px -->
      <div class="show-over-320px-under-768px" style="width: 100%; padding: 40px 0px 40px; background-color: #01010D">
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div style="width: calc(100% - calc(16px * 2)); position: relative">
            <!-- (주)코그콤 -->
            <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #ffffff; margin-bottom: 10px">
              (주)코그콤
            </div>
            <!-- 정보1 -->
            <div class="d-flex flex-wrap align-center" style="margin-bottom: 10px">
              <!-- 대표 정치훈 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                대표 정치훈
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 전화 02-2088-2096 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                전화 02-2088-2096
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 메일 contact@cogcom.kr -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                메일 contact@cogcom.kr
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
              </div>
              <!-- 사업자등록번호 378-86-01944 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                사업자등록번호 378-86-01944
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFFB2; margin: 0px 4px"></div>
              <!-- 통신판매업 제2024-서울광진-1178호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #ffffff">
                통신판매업 제2024-서울광진-1178호
              </div>
            </div>
            <!-- 하단 버튼 (코그콤 블로그 버튼, 코그콤 링크드인, 리컬럼) -->
            <div class="d-flex align-center" style="gap: 6px">
              <!-- 코그콤 블로그 버튼 -->
              <div @click="openBlog()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/blog-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 코그콤 링크드인 버튼 -->
              <div @click="openLinkedIn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="@/assets/footer/linked-in-logo-ffffff.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 리컬럼 버튼 -->
              <div @click="openRecolumn()" class="d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <v-icon style="font-size: 24px; color: #ffffff">
                  mdi-web
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",

  data() {
    return {
      section1_tab: 0,
      partner_list: [
        { src: 'ibk.svg' },
        { src: 'mercedesbenz.svg' },
        { src: 'kundal.svg' },
        { src: 'youngtoy.svg' },
        { src: 'dewytree.svg' },
        { src: 'navercloud.svg' },
        { src: 'coex.svg' },
        { src: 'usave.svg' },
        { src: 'kcisa.svg' },
        { src: 'genstarmate.svg' },
        { src: 'knuhospital.svg' },
        { src: 'hibetter.svg' },
        { src: 'goldenbridge.svg' },
        { src: 'rirosoft.svg' },
        { src: 'mnd.svg' },
        { src: 'gccare.svg' },
        { src: 'kodit.svg' },
        { src: 'prosecution.svg' },
        { src: 'seoulgov.svg' },
        { src: 'knu.svg' },
        { src: 'n15.svg' },
      ],
    }
  },

  methods: {
    openGoogleForm() {
      console.log('openGoogleForm')
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSfzSDiA4w-MdVhY_huzxVm8E_Y4yJVSWqmHvSxcoOPZtQSTRg/viewform')
    },
    openRecolumn() {
      console.log('openRecolumn')
      window.open('https://www.recolumn.com/')
    },
    openLinkedIn() {
      console.log('openLinkedIn')
      window.open('https://www.linkedin.com/company/cogcom-inc/')
    },
    openBlog() {
      console.log('openBlog')
      window.open('https://blog.naver.com/PostList.naver?blogId=cogcominc')
    },
  },
}
</script>

<style scoped>
* {
  word-break: keep-all;
}

.section-1-wrapper img {
  display: block;
}
.section-1 {
  background: url('../assets/home_section1/section1_bg_img.png');
  object-fit: cover;
  object-position: center;
}

.section-4-box:hover img {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

/* 490px 이하 */
@media (max-width: 490px) {
  .hide-under-490px { display: none; }
}
/* 400px 이하 */
@media (max-width: 400px) {
  .hide-under-400px { display: none; }
}
</style>